import { Locale, SubtitleTextColors, SubtitleTextSizes } from '../typings';

export const fr_CA: Locale = {
  name: 'fr_CA',
  translations: {
    General: {
      On: 'Activé',
      Off: 'Désactivé',
    },
    BottomControls: {
      PlayingOn: (device: string) => `Lecture sur ${device}`,
    },
    ContextMenuOverlay: {
      Version: (version: string) => `Version: ${version}`,
      PoweredByBeachbody: 'Propulsé par Beachbody',
    },
    ErrorOverlay: {
      ErrorCode: (code: number) => `Erreur ${code}`,
      CannotBePlayed: 'Cette vidéo ne peut pas être lue.',
      PleaseTryAgain: 'Veuillez réessayer ultérieurement.',
    },
    LanguageOptions: {
      Subtitles: 'Sous-titres',
      SubtitleOptions: 'Options',
      Audio: 'Audio',
    },
    SubtitleOptions: {
      FontSize: 'Taille de la police',
      TextSizeOption: (textSize) => {
        switch (textSize) {
          case SubtitleTextSizes.Smallest:
            return 'La plus petite';
          case SubtitleTextSizes.Small:
            return 'Petite';
          case SubtitleTextSizes.Normal:
            return 'Normale';
          case SubtitleTextSizes.Large:
            return 'Grande';
          case SubtitleTextSizes.Largest:
            return 'La plus grande';
          default:
            return 'Normale';
        }
      },
      TextColorOption: (textColor) => {
        switch (textColor) {
          case SubtitleTextColors.White:
            return 'Blanc';
          case SubtitleTextColors.Gray:
            return 'Gris';
          case SubtitleTextColors.Black:
            return 'Noir';
          case SubtitleTextColors.Yellow:
            return 'Jaune';
          case SubtitleTextColors.Orange:
            return 'Orange';
          case SubtitleTextColors.Red:
            return 'Rouge';
          case SubtitleTextColors.Green:
            return 'Vert';
          case SubtitleTextColors.Cyan:
            return 'Cyan';
          case SubtitleTextColors.Blue:
            return 'Bleu';
          default:
            return 'Blanc';
        }
      },
      FontColor: 'Couleur de la police',
      BoldText: 'Texte en gras',
    },
    ModifierIndicator: {
      Modifier: 'Variante',
    },
    ResumeOverlay: {
      AboutToPlay: 'Sur le point de jouer',
      ResumeVideo: 'Reprendre la vidéo',
      StartOver: 'Recommencer',
    },
  },
};
